// Client Intelligence: the routes and the sidebar rows of `wealth.intelligence.client` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.intelligence.client',
    routes: [
        {
            frontend: 'view',
            path: 'client-intelligence',
            lazy: () => import('@/pages/view/client-intelligence/page'),
        },
    ],
    nav: [
        {
            frontend: 'view',
            key: 'client-intelligence',
            label: 'Client Intelligence',
            href: '/view/client-intelligence',
            icon: 'Users',
            group: 'intelligence',
            order: 320,
        },
    ],
});
